'use client';

import { GOOGLE_ADS_SCRIPT_SRC } from '@/utils/helpers/constants';
import { useEffect } from 'react';

const GoogleAdsScript = () => {
  useEffect(() => {
    if (window.location.hostname === process.env.NEXT_PUBLIC_REWRITE_DOMAIN_NAME) {
      const adsScript = document.createElement('script');
      adsScript.async = true;
      adsScript.src = GOOGLE_ADS_SCRIPT_SRC;
      adsScript.crossOrigin = 'anonymous';
      document.head.appendChild(adsScript);

      return () => {
        document.head.removeChild(adsScript);
      };
    } else {
      return () => {};
    }
  }, []);

  return null;
};

export default GoogleAdsScript;
